import Media from './media';

export default Media;
